function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as cardCouponApi from '@/api/cardCouponApi';
import * as empTagApi from '@/api/empTagApi';
import CardCouponDialog from './components/CardCouponDialog.vue';
import PriceRecordsDialog from './components/PriceRecordsDialog.vue';
export default {
  name: 'CardCouponList',
  components: {
    CardCouponDialog: CardCouponDialog,
    PriceRecordsDialog: PriceRecordsDialog
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        productName: '',
        restrictedArea: '',
        status: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      companyList: [],
      parkingLotList: [],
      fucardList: []
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
    this.loadDialogData();
  },
  methods: {
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      cardCouponApi.getCardCouponList(this.listPram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        productName: '',
        restrictedArea: '',
        status: ''
      };
      this.handlerGetListData();
    },
    loadDialogData: function loadDialogData() {
      var _this2 = this;
      empTagApi.getTagAutocomplete('').then(function (res) {
        _this2.companyList = res;
      });
      cardCouponApi.getParkingLotList('').then(function (res) {
        _this2.parkingLotList = res;
      });
      cardCouponApi.getFucardList('').then(function (res) {
        _this2.fucardList = res;
      });
    },
    // 加载弹窗所需的基础数据
    // Promise.all([
    // ]).then(([tags, parkingLots, fucards]) => {
    //   // 处理标签数据，将 {tagId, tagName} 格式转换为组件需要的格式
    //   this.companyList = tags
    //   this.parkingLotList = parkingLots || []
    //   this.fucardList = fucards || []
    //   console.log(this.companyList,'this.companyList');
    //   console.log(this.parkingLotList,'this.parkingLotList');
    //   console.log(this.fucardList,'this.fucardList');
    // }).catch(() => {
    //   this.$message.error('加载基础数据失败')
    // })
    handleAdd: function handleAdd() {
      this.$refs.cardCouponDialogRef.open({});
    },
    handleEdit: function handleEdit(row) {
      var _this3 = this;
      cardCouponApi.getCardCouponDetail(row.id).then(function (res) {
        console.log(res, 'res');
        _this3.$refs.cardCouponDialogRef.open(res);
      }).catch(function (err) {
        console.log(err, 'err');
        _this3.$message.error('获取商品详情失败');
      });
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this4 = this;
      var action = row.status === 1 ? '下架' : '上架';
      var api = row.status === 1 ? cardCouponApi.offShelfCardCoupon : cardCouponApi.putOnShelfCardCoupon;
      this.$confirm("\u786E\u5B9A\u8981".concat(action, "\u8BE5\u5361\u5238\u5546\u54C1\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api(row.id).then(function () {
          _this4.$message.success("".concat(action, "\u6210\u529F"));
          _this4.handlerGetListData();
        }).catch(function () {
          _this4.$message.error("".concat(action, "\u5931\u8D25"));
        });
      });
    },
    handlePriceRecords: function handlePriceRecords(row) {
      this.$refs.priceRecordsDialogRef.open(row.id);
    },
    handleCopy: function handleCopy(row) {
      var _this5 = this;
      cardCouponApi.getCardCouponDetail(row.id).then(function (res) {
        // 复制数据，移除id字段
        var copyData = _objectSpread({}, res);
        delete copyData.id;
        // 打开对话框，此时因为没有id，会显示为"添加卡券"
        _this5.$refs.cardCouponDialogRef.open(copyData);
      }).catch(function (err) {
        console.log(err, 'err');
        _this5.$message.error('获取商品详情失败');
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    }
  }
};